import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AuthService } from '../../services/auth/auth.service';
import { VideoPortalUser } from '../../services/auth/video-portal-user.model';

@Component({
    selector: 'app-nav-tabs',
    templateUrl: './nav-tabs.component.html',
    styleUrls: ['./nav-tabs.component.css']
})
export class NavTabsComponent implements OnInit, OnDestroy {
    currentUser: VideoPortalUser | null = null;
    private destroy$ = new Subject<void>();

    constructor(private authService: AuthService) {
    }

    ngOnInit(): void {
        this.authService.userInfoSubject
            .pipe(takeUntil(this.destroy$))
            .subscribe(user => {
                this.currentUser = user;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    isAuthenticated(): boolean {
        return !!this.currentUser;
    }

    isInRole(role: string): boolean {
        return !!this.currentUser && this.currentUser.isInRole(role);
    }

    showUsageReports(): boolean {
        return !!this.currentUser &&
            this.currentUser.isInRole('jjr') && this.currentUser.hasAdminRole;
    }
}
